module.exports = __webpack_public_path__ + "static/media/gceBg.375413c2.png";